import z from "zod";
import { BaseTaskFormSchema } from "../closeTemplateTasksDrawer.constants";

export const TemplateTaskDetailsSchema = BaseTaskFormSchema.extend({
    assigneeId: z.number().int().nullable(),
});

export type TemplateTaskDetailsValues = z.infer<
    typeof TemplateTaskDetailsSchema
>;
